(function () {
  'use strict';

  Controller.$inject = ['SensorService', '$rootScope', '$state', 'AppUtils'];

  window.angular.module('app').component('sequenceDataDisplay', {
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      sensor: '<',
      assetName: '<',
      data: '<',
      onlyContent: '<',
      options: '<',
      disableClick: '<',
      onLoadContent: '=',
      maxHeight: '<',
      disableSpinner: '<',
      filterByZone: '<',
    },
    template:'<div class="panel panel-default rt-panel rt-panel-sm" ng-if="!ctrl.onlyContent"><header class="panel-heading"><h2 class="nowrap"><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right" ng-if="ctrl.image"><div class="panel-toolbar"><div class="btn-group" data-toggle="buttons"><label ng-click="ctrl.viewMode = \'image\'" ng-class="{active: ctrl.viewMode === \'image\'}" class="btn btn-default btn-xs" title="Imagen"><input type="radio"> <i class="fas fa-image"></i></label> <label ng-click="ctrl.viewMode = \'raw\'" ng-class="{active: ctrl.viewMode === \'raw\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'general.details\'}"><input type="radio"> <i class="fas fa-code"></i></label></div></div></div></header><div class="panel-body" ng-class="{\'with-location\': ctrl.data.location}"><div class="rt-content"><div ng-if="ctrl.content"><div ng-if="ctrl.viewMode=== \'image\'"><a style="display: block" ng-class="{\'cursor-pointer\': !ctrl.disableClick}" ng-click="ctrl.expand()" target="_blank"><image-sequence detections="ctrl.detections" images-src="ctrl.imagesSrc" max-height="ctrl.maxHeight" on-load-content="ctrl.onLoadContent" dimensions="ctrl.dimensions" sensor="ctrl.sensor" data="ctrl.data" filter-by-zone="ctrl.filterByZone"></image-sequence></a></div><pre ng-if="ctrl.viewMode=== \'raw\'">{{ctrl.content | json}}</pre></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div><div class="rt-footer"><div class="date" ng-if="ctrl.content">{{ctrl.data.from | date: "yyyy-MM-dd HH:mm:ss"}}<div ng-if="ctrl.data.location"><a target="_blank" ng-href="https://www.google.com/maps/search/?api=1&query={{ctrl.data.location.coordinates[1]}},{{ctrl.data.location.coordinates[0]}}">[ {{ctrl.data.location.coordinates[1]}}, {{ctrl.data.location.coordinates[0]}} ]</a></div></div><div class="rt-footer chart-footer" ng-if="ctrl.data && !ctrl.data.content"><div class="small" translate>errors.NOT_DATA_FOUND</div></div><div class="rt-footer chart-footer" ng-if="!ctrl.data"><div class="small"><i translate>general.loading</i><i>...</i></div></div></div></div></div><div ng-if="ctrl.onlyContent" class="rt-content" style="top: 0; bottom: 0; right: 0; left: 0"><div ng-if="ctrl.content"><div ng-if="ctrl.viewMode=== \'image\'"><a style="display: block" ng-class="{\'cursor-pointer\': !ctrl.disableClick}" ng-click="ctrl.expand()" target="_blank"><image-sequence detections images-src="ctrl.imagesSrc" max-height="ctrl.maxHeight" on-load-content="ctrl.onLoadContent" dimensions="ctrl.dimensions" sensor="ctrl.sensor" data="ctrl.data" filter-by-zone="ctrl.filterByZone"></image-sequence></a></div><pre ng-if="ctrl.viewMode=== \'raw\'">{{ctrl.content | json}}</pre></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div>',
  });

  function Controller(SensorService, $root, $state, utils) {
    let vm = this;
    vm.viewMode = 'raw';

    vm.$onInit = function () {
      getImages();

      vm.state = $state.get().reduce((filtered, current) => {
        const name = current.name;
        const component = current.component;
        if (name.includes('dataDisplay') && component === 'monitoringDataDisplay') {
          filtered.push(current);
        }
        return filtered;
      }, [])[0];

      vm.dimensions = {};
      vm.onLoadImage = onLoadImage;
      vm.expand = expand;
    };

    vm.$onChanges = function () {
      vm.disableSpinner = typeof vm.disableSpinner === 'boolean' ? vm.disableSpinner : false;
      if (!vm.data) {
        return;
      }

      vm.content = vm.data.content;
      getImages();

      if (vm.images?.length) {
        vm.detections = vm.content.detections || vm.content.objects;
        vm.imagesSrc = vm.images.map((image) => SensorService.getImageUrl(vm.sensor.id, image));
      }
      vm.viewMode = vm.images?.length ? 'image' : 'raw';
    };

    function getImages() {
      if (vm.content) {
        vm.images = vm.content.files ? vm.content.files.sequence : null;
        if (vm.images) {
          utils.sortArrayByField(vm.images, 'originalFilename');
        }
      } else {
        vm.images = null;
      }
    }

    function onLoadImage(err, images) {
      if (vm.onLoadContent) {
        vm.onLoadContent(err, images);
      }
    }

    function expand() {
      if (vm.disableClick) {
        return;
      }

      const dataId = vm.data.referenceId || vm.data.id;
      window.open(
        $state.href(
          vm.state,
          {
            projectId: $root.projectId,
            assetId: vm.sensor.assetId,
            sensorId: vm.sensor.id,
            dataId: utils.isDate(dataId) ? dataId.getTime() : dataId,
            zoneFilter: true,
          },
          '_blank'
        )
      );
    }
  }
})();
